// extracted by mini-css-extract-plugin
export default {"list_container":"AdminSettings_list_container__T7Q0B"};